module.exports = __webpack_public_path__ + "img/ecpm.7d529377.svg";